package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Bosnia and Herzegovina Flag (32x24dp)
 *
 * - ISO Alpha-2: BA
 * - ISO Alpha-3: BIH
 * - ISO Numeric: 070
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.BosniaAndHerzegovina: ImageVector by lazy {
    ImageVector.Builder(
        name = "Bosnia and Herzegovina:BA:BIH:070:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(32f)
                verticalLineTo(24f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9f, 0f)
                horizontalLineTo(29f)
                verticalLineTo(24f)
                lineTo(9f, 0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.108f, 2.794f)
                lineTo(4.932f, 3.412f)
                lineTo(5.157f, 2.103f)
                lineTo(4.206f, 1.176f)
                lineTo(5.52f, 0.985f)
                lineTo(6.108f, -0.206f)
                lineTo(6.696f, 0.985f)
                lineTo(8.01f, 1.176f)
                lineTo(7.059f, 2.103f)
                lineTo(7.284f, 3.412f)
                lineTo(6.108f, 2.794f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.595f, 7.074f)
                lineTo(8.419f, 7.692f)
                lineTo(8.644f, 6.383f)
                lineTo(7.693f, 5.456f)
                lineTo(9.007f, 5.265f)
                lineTo(9.595f, 4.074f)
                lineTo(10.182f, 5.265f)
                lineTo(11.497f, 5.456f)
                lineTo(10.546f, 6.383f)
                lineTo(10.77f, 7.692f)
                lineTo(9.595f, 7.074f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.863f, 11.238f)
                lineTo(11.688f, 11.856f)
                lineTo(11.912f, 10.547f)
                lineTo(10.961f, 9.62f)
                lineTo(12.276f, 9.429f)
                lineTo(12.863f, 8.238f)
                lineTo(13.451f, 9.429f)
                lineTo(14.766f, 9.62f)
                lineTo(13.814f, 10.547f)
                lineTo(14.039f, 11.856f)
                lineTo(12.863f, 11.238f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(16.065f, 15.229f)
                lineTo(14.89f, 15.847f)
                lineTo(15.114f, 14.538f)
                lineTo(14.163f, 13.611f)
                lineTo(15.477f, 13.42f)
                lineTo(16.065f, 12.229f)
                lineTo(16.653f, 13.42f)
                lineTo(17.967f, 13.611f)
                lineTo(17.016f, 14.538f)
                lineTo(17.241f, 15.847f)
                lineTo(16.065f, 15.229f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(19.514f, 19.337f)
                lineTo(18.339f, 19.955f)
                lineTo(18.563f, 18.646f)
                lineTo(17.612f, 17.719f)
                lineTo(18.927f, 17.528f)
                lineTo(19.514f, 16.337f)
                lineTo(20.102f, 17.528f)
                lineTo(21.417f, 17.719f)
                lineTo(20.465f, 18.646f)
                lineTo(20.69f, 19.955f)
                lineTo(19.514f, 19.337f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(23.327f, 23.311f)
                lineTo(22.151f, 23.929f)
                lineTo(22.376f, 22.62f)
                lineTo(21.425f, 21.693f)
                lineTo(22.739f, 21.502f)
                lineTo(23.327f, 20.311f)
                lineTo(23.915f, 21.502f)
                lineTo(25.229f, 21.693f)
                lineTo(24.278f, 22.62f)
                lineTo(24.503f, 23.929f)
                lineTo(23.327f, 23.311f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun BosniaAndHerzegovinaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.BosniaAndHerzegovina,
            contentDescription = "Bosnia and Herzegovina Flag"
        )
    }
}
